import e from "@mui/material/styles/shadows";
const r = Object.assign(
  {
    centered: "0 0.4rem 1rem rgba(0, 0, 0, 0.15), 0 0 0.6rem rgba(0, 0, 0, 0.15)"
  },
  e
);
r[1] = "0 0.2rem 0.4rem rgba(0, 0, 0, 0.15)";
r[2] = "0 0.4rem 0.8rem rgba(0, 0, 0, 0.15)";
r[3] = "0 0.8rem 1.6rem rgba(0, 0, 0, 0.15)";
export {
  r as default
};
//# sourceMappingURL=shadows.js.map
